import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';
import { type PlanServiceNestedUniverse } from '../../../../../../src/types/PlanServiceNestedUniverse';

export const planServiceNestedUniversePath = () => {
  return `/api/v2/plan_service/occasion_groups/view_nested_universe/`;
};

export type PlanUniverseQueryParams =
  | {
      is_available_pre_checkout: 1;
      is_available_post_checkout?: never;
    }
  | {
      is_available_pre_checkout?: never;
      is_available_post_checkout: 1;
    };

export async function planServiceNestedUniverseRequest(
  queryParams?: PlanUniverseQueryParams
) {
  const query = new URLSearchParams();
  if (queryParams?.is_available_post_checkout) {
    query.append(
      'is_available_post_checkout',
      String(queryParams?.is_available_post_checkout)
    );
  }

  if (queryParams?.is_available_pre_checkout) {
    query.append(
      'is_available_pre_checkout',
      String(queryParams?.is_available_pre_checkout)
    );
  }

  return await send<PlanServiceNestedUniverse>({
    method: 'GET',
    path: planServiceNestedUniversePath(),
    query,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
